import { render, staticRenderFns } from "./ComponentsReportModal.vue?vue&type=template&id=1a65cbbd&"
import script from "./ComponentsReportModal.js?vue&type=script&lang=js&"
export * from "./ComponentsReportModal.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports